import { network } from 'services/network';
import { useMutation } from 'react-query';
import qs from 'qs';
import { TMfaType } from 'components/Settings/Components/UsersManagement/queries/useQueryUsersManagement';
import { activeDirectory, token } from 'services/LocalStorage/localStorage';
import { useProjectTreeStore } from 'store/projectContract.store';

const mutationFn = (params: QueryParams) => {
    const querystring = qs.stringify({ userName: params.userName }, { addQueryPrefix: true, skipNulls: true });
    const update = useProjectTreeStore.getState().update;

    return network.post(`admin/bo/switchUser${querystring}`).then((response) => {
        token.set(response.data.accessToken);
        network.defaults.headers.common['Authorization'] = `Bearer ${response.data.accessToken}`;
        activeDirectory.set(
            window['ENV_VARIABLES'] ? window['ENV_VARIABLES']['REACT_APP_ACTIVE_DIRECTORY_URL'] : activeDirectory.get(),
        );
        update({ project: null, contract: null, parentNode: null, currentList: [] });
        return response.data;
    });
};

export const useMutationSwitchUser = () => {
    return useMutation<QueryResponse, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

interface QueryParams {
    userName: string;
}

interface QueryResponse {
    accessToken: string;
    customerId: null;
    defaultProjectId: number;
    email: string;
    mfa: TMfaType;
    phone: null;
    tokenType: 'Bearer';
}
